import * as Actions from 'store/actions/app/proformas.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_proformas: false,
  proformas: [],
  total_proformas: 0,

  loading_proforma: false,
  proforma: null,

  saving_proforma: false,
  saved_proforma: false,
  saved_proforma_data: null,

  finishing_proforma_register: false,
  finished_proforma_register: false,

  voiding_proforma_ids: [],
  voided_proforma_ids: [],
}

const proformasReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PROFORMAS: {
      return {
        ...state,
        loading_proformas: action.payload.loading ?? state.loading_proformas,
        proformas: action.payload.items ?? state.proformas,
        total_proformas: action.payload.total ?? state.total_proformas,
      }
    }
    case Actions.GET_PROFORMA_BY_ID: {
      return {
        ...state,
        loading_proforma: action.payload.loading ?? state.loading_proforma,
        proforma: action.payload.data ?? state.proforma,
      }
    }
    case Actions.RESET_PROFORMA_BY_ID: {
      return { ...state, proforma: null }
    }
    case Actions.SAVE_PROFORMA: {
      return {
        ...state,
        saving_proforma: action.payload.saving ?? state.saving_proforma,
        saved_proforma: action.payload.saved ?? false,
        saved_proforma_data: action.payload.data ?? null,
        proformas: action.payload.data
          ? addOrUpdateObjectInArray(state.proformas, action.payload.data, 'id', true)
          : state.proformas,
      }
    }
    case Actions.FINISH_PROFORMA_REGISTER: {
      return {
        ...state,
        finishing_proforma_register: action.payload.finishing ?? state.finishing_proforma_register,
        finished_proforma_register: action.payload.finished ?? false,
        proformas: action.payload.data
          ? addOrUpdateObjectInArray(state.proformas, action.payload.data, 'id')
          : state.proformas,
      }
    }
    case Actions.VOID_PROFORMA: {
      return {
        ...state,
        voiding_proforma_ids: toggleIdInArray(state.voiding_proforma_ids, action.payload.voiding_id),
        voided_proforma_ids: toggleIdInArray(state.voided_proforma_ids, action.payload.voided_id),
        proformas: action.payload.data
          ? addOrUpdateObjectInArray(state.proformas, action.payload.data, 'id')
          : state.proformas,
      }
    }
    default: {
      return state
    }
  }
}

export default proformasReducer
